import { render, staticRenderFns } from "./instagram_campaign_prize.vue?vue&type=template&id=d76bdb34"
import script from "./instagram_campaign_prize.vue?vue&type=script&lang=ts"
export * from "./instagram_campaign_prize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports